module.exports = __webpack_public_path__ + "img/way_image_01.dbd4a21.svg";